
import Http from "../../http/client";
import Store from "../index";

export default async () => {
  const response = await Http.get('admin/city');
  Store.commit('SetCity', response.data);
}
